import { createFeatureSelector } from '@ngrx/store';
import { SERVICE_REQUEST_COMPLETED, ServiceRequestCompletedState } from './service-request-completed.state';

export const getDataServiceRequestCompleted =
  createFeatureSelector<ServiceRequestCompletedState>(SERVICE_REQUEST_COMPLETED);
